import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import PortfolioSection from './components/PortfolioSection';
import ReviewsSection from './components/ReviewsSection';
import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import RefundSection from './components/RefundSection';

const HomePage = () => {
  useEffect(() => {
    // SEO Meta Tags
    document.title = '유흥디자인랩 - 유흥업계 전문 광고·홍보 디자인 | 구인광고 홈페이지제작';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '유흥업계 전문 구인광고 디자인과 업체 홍보 홈페이지 제작. 1~3일 내 완성, 합리적인 가격으로 전문적인 결과물을 제공합니다. 구인광고 5만원, 홈페이지 제작 10만원부터 시작하세요. 박스구인, 실장구인, 가게홍보 전문 디자인 서비스.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '유흥광고, 유흥디자인, 구인광고, 홈페이지제작, 업체홍보, 박스구인, 실장구인, 가게홍보,유흥업체홍보,유흥실장홍보,안마,마사지,테더코인,유흥업계광고,구인광고');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "유흥디자인랩",
      "description": "유흥업계 전문 구인광고 디자인과 업체 홍보 홈페이지 제작 서비스",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Seoul",
        "addressRegion": "Seoul",
        "addressCountry": "KR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "37.5665",
        "longitude": "126.9780"
      },
      "priceRange": "₩50,000 - ₩100,000",
      "areaServed": {
        "@type": "City",
        "name": "Seoul"
      },
      "serviceType": ["구인광고 디자인", "홈페이지 제작", "업체 홍보"],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "디자인 서비스",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "구인광고 디자인",
              "description": "박스/실장/가게 구인 전용 광고페이지 제작"
            },
            "price": "50000",
            "priceCurrency": "KRW"
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "홈페이지 제작",
              "description": "업체 홍보·모객 전용 웹사이트"
            },
            "price": "100000",
            "priceCurrency": "KRW"
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <PricingSection />
        <PortfolioSection />
        <ReviewsSection />
        <ProcessSection />
        <FAQSection />
        <RefundSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;